<template>
  <div>
    <v-row
      dense
      class="mt-2 mr-2 crud-permission-grid"
      :class="{ 'mb-2': readonly }"
    >
      <v-col cols="5"></v-col>
      <v-col cols="7">
        <v-row
          no-gutters
          align="center"
          justify="space-around"
          class="mt-0 text-center"
        >
          <v-col v-for="suffix in crudSuffixes" :key="suffix">
            <v-subheader
              class="pl-0 pr-1 font-weight-bold justify-center"
              style="height: 24px;"
            >
              {{ trans.crudSuffix(suffix) }}
            </v-subheader>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row
      v-if="!readonly"
      dense
      class="mt-0 crud-permission-grid"
      style="margin-right: 9px !important;"
    >
      <v-col cols="5" class="py-0">
        <v-checkbox
          id="form-checkbox-select-all"
          :value="isCheckedAll()"
          class="pl-2 pb-0 pt-1 pr-0 ma-0"
          hide-details
          @click="selectAll()"
        >
          <template #label>
            <v-subheader class="px-0 font-weight-bold" style="height: 24px;">
              Выбрать все
            </v-subheader>
          </template>
        </v-checkbox>
      </v-col>
      <v-col cols="7" class="pb-3 pt-0">
        <v-row no-gutters align="center" justify="space-around">
          <div v-for="suffix in crudSuffixes" :key="suffix">
            <v-checkbox
              :id="`form-checkbox-select-column-${suffix}`"
              :value="isCheckedColumn(suffix)"
              hide-details
              width="50"
              class="mt-0"
              :disabled="permissionCounts[suffix] === 0"
              @click="selectSuffix(suffix)"
            />
          </div>
        </v-row>
      </v-col>
    </v-row>

    <v-divider style="border-top-width: 2px;" />

    <div
      v-resize="onResize"
      class="crud-permission-grid"
      style="overflow-y: scroll; overflow-x: hidden;"
      :style="{ height: height(parseInt(heightOffset)) }"
    >
      <div
        v-for="item in permissionTreeFiltered"
        :key="`${item.kind}-${item.id}`"
      >
        <permission-row
          v-if="item.kind == 'nav'"
          v-model="selectedPermissions.navs"
          :permission-row="item"
          :crud-suffixes="crudSuffixes"
          :readonly="readonly"
        />
        <permission-row
          v-else-if="item.kind == 'realm_class_link'"
          v-model="selectedPermissions.realmClassLinks"
          :permission-row="item"
          :crud-suffixes="crudSuffixes"
          :readonly="readonly"
        />
      </div>
    </div>
  </div>
</template>
<script>
import ResizeMixin from "@/mixins/ResizeMixin";
import PermissionRow from "./PermissionRow";
import EventBus from "@/utils/EventBus";
export default {
  components: { PermissionRow },
  mixins: [ResizeMixin],
  props: {
    value: {
      type: Object,
      required: true
    },
    permissionTree: {
      type: Array,
      required: true
    },
    heightOffset: {
      type: [Number, String],
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      permissions: {},
      permissionCounts: {},
      crudSuffixes: ["view", "add", "edit", "delete"]
    };
  },
  computed: {
    permissionTreeFiltered() {
      return this.permissionTree.filter(item => this.visibleInCrud(item));
    },
    selectedPermissions: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    trans() {
      return { crudSuffix: suffix => this.$t(`Common.crud.${suffix}`) };
    }
  },
  watch: {
    permissionTree(v) {
      this.mapPermissions(v);
    }
  },
  created() {
    this.mapPermissions(this.permissionTree);
  },
  methods: {
    mapPermissions(permRows) {
      permRows.forEach(row => {
        if (row.permissions.length > 0) {
          this.crudSuffixes.forEach(suffix => {
            const perm = row.permissions.find(p => p.permission == suffix);
            if (!this.permissionCounts[suffix])
              this.$set(this.permissionCounts, suffix, 0);
            if (!this.permissions[suffix])
              this.$set(this.permissions, suffix, []);
            if (perm) {
              this.permissionCounts[suffix]++;
              this.permissions[suffix].push(perm.id);
            }
          });
        }
        if (row.children) {
          this.mapPermissions(row.children);
        }
      });
    },
    visibleInCrud(row) {
      if (row.children !== undefined && row.children.length > 0) return true;
      return row.permissions.some(item =>
        this.crudSuffixes.some(suffix => suffix == item.permission)
      );
    },
    selectSuffix(suffix) {
      const value = !this.isCheckedColumn(suffix);
      EventBus.$emit("select-permission-column", { suffix, value });
    },
    selectAll() {
      const value = !this.isCheckedAll();
      const suffixes = value
        ? this.crudSuffixes.slice()
        : this.crudSuffixes.slice().reverse();
      suffixes.forEach(suffix =>
        EventBus.$emit("select-permission-column", { suffix, value })
      );
    },
    isCheckedColumn(suffix) {
      const { permissions, selectedPermissions } = this;
      if (!permissions[suffix]) return false;
      let isSet = true;
      permissions[suffix].forEach(id => {
        if (!isSet) return;
        isSet = selectedPermissions[id] === true;
      });
      return isSet;
    },
    isCheckedAll() {
      return !this.crudSuffixes.some(suffix => !this.isCheckedColumn(suffix));
    }
  }
};
</script>
